import styled from '@grebban/style-system-react';

/**
 * Simple styled svg "path" component.
 */

export default styled('path')``;
